{
 "home": [
  "PoliPoker_Intro.mp3"
 ],
 "las-vegas-high-roller": [
  "Everybodys_a_Quocker.mp3",
  "Who_Dealt_This_Gurge.mp3"
 ],
 "orient-express": [
  "Midnight_On_the_Orient_Express.mp3",
  "Two_Seats_to_Vienna.mp3"
 ],
 "roaring-twenties": [
  "Patched_Up_Suit.mp3"
 ],
 "wild-west-saloon": [
  "A_Chair_Beside_the_Door.mp3",
  "Fifty_States_Beneath_the_Stars.mp3",
  "Joe_Bowers_Letter.mp3",
  "Sweet_Betsy_from_Pike.mp3"
 ]
}
